import { HotkeyEntry } from './types'

const HOTKEYS: HotkeyEntry[] = [
  {
    keys: ['⌘', 'K'],
    description: 'Open the command palette',
  },
  {
    keys: ['?'],
    description: 'Show this cheatsheet',
  },
  {
    keys: ['Esc'],
    description: 'Close any open overlay',
  },
  {
    keys: ['↑', '↓'],
    description: 'Navigate within palette + drawers',
  },
  {
    keys: ['↵'],
    description: 'Run the highlighted command',
  },
  {
    keys: ['7×'],
    description: 'Click the QuickPass wordmark seven times for a secret',
  },
  {
    keys: ['↑↑↓↓←→←→ B A'],
    description: 'You know what this does',
  },
]

export { HOTKEYS }
